// SAD-900: which teams own a deliverable for list filters and the team pages —
// read from the award rules and the owners pangaea names on each of them, not
// only dates in the current occurrence window.
/** Award rules (never a SOW's team rules). */ export function awardOwnershipRules(rules) {
    return rules.filter((r)=>!r.assignmentId && r.gate !== 'sow');
}
const isPeriodGate = (r)=>r.gate === 'base' || r.gate === 'option_period';
/**
 * Whether a base or option-period rule is owed in the window: its own period
 * when the window is a contract period, else a period that overlaps the
 * window (a team's current window spans its SOWs, not one period).
 */ function periodRuleOwed(r, window, periodOf) {
    const pop = window?.periodOfPerformanceId ?? '';
    if (pop) return r.periodOfPerformanceId === pop;
    const from = window?.startOn ?? '';
    const to = window?.endOn ?? '';
    const p = r.periodOfPerformanceId ? periodOf?.(r.periodOfPerformanceId) : undefined;
    if (!p) return true;
    return (!p.end || !from || p.end >= from) && (!p.start || !to || p.start <= to);
}
function effectiveInWindow(r, window) {
    const from = window?.startOn ?? '';
    const to = window?.endOn ?? '';
    return (!r.effectiveTo || !from || r.effectiveTo >= from) && (!r.effectiveFrom || !to || r.effectiveFrom <= to);
}
/**
 * Whether the Contract-wide team page lists this deliverable for the given
 * contract window: a contract-wide date, or an award rule owed in the window
 * that no team's line owns (gated on base / option period with no owners, or
 * whenever), or no rule at all. SOW-origin duties stay off unless they
 * already have a contract-wide date.
 */ export function isOwedContractWide(duty, rules, window, hasContractWideOccurrence = false, periodOf) {
    if (hasContractWideOccurrence) return true;
    const from = window?.startOn ?? '';
    if (duty.endedOn && from && duty.endedOn < from) return false;
    if (duty.origin === 'sow') return false;
    // No rules at all ⇒ owed contract-wide.
    if (rules.length === 0) return true;
    return awardOwnershipRules(rules).some((r)=>effectiveInWindow(r, window) && (r.gate === 'none' || isPeriodGate(r) && !(r.ownerWorkstreamIds ?? []).length && periodRuleOwed(r, window, periodOf)));
}
/**
 * The teams whose lines own an award rule of the deliverable owed in the
 * window (SAD-861): such a team owes the deliverable there, dated or not.
 */ export function lineOwnerTeams(duty, rules, window, periodOf) {
    const teams = new Set();
    const from = window?.startOn ?? '';
    if (duty.endedOn && from && duty.endedOn < from) return teams;
    for (const r of awardOwnershipRules(rules)){
        if (!isPeriodGate(r) || !effectiveInWindow(r, window) || !periodRuleOwed(r, window, periodOf)) continue;
        for (const ws of r.ownerWorkstreamIds ?? [])teams.add(ws);
    }
    return teams;
}
/**
 * Team ids for the deliverables list filter: dated occurrence workstreams,
 * the teams whose lines own the deliverable in the window, plus "" when it is
 * owed contract-wide.
 */ export function deliverableTeamIds(occurrenceTeamIds, duty, rules, window) {
    const teams = new Set();
    for (const id of occurrenceTeamIds){
        teams.add((id ?? '').trim());
    }
    for (const ws of lineOwnerTeams(duty, rules, window))teams.add(ws);
    if (isOwedContractWide(duty, rules, window, teams.has(''))) teams.add('');
    return teams;
}
